<template lang="pug">        
    v-container( fluid pa-0 )
        v-layout( row wrap )
            v-flex( xs12 sm6 )
                v-subheader( class="primary px-4" dark ) Haberes
                v-subheader( class="blue px-4" dark ) Imponibles
                v-data-table( :headers="headers" hide-actions hide-headers :items="items.imponibles" )
                    template( slot="items" slot-scope="props" :rowSpan="props.item.rowSpan || 0" )
                        td {{ props.item.name }}
                        td( class="text-xs-right" width="40%" ) $ {{ props.item.value | mixThousandSeparatorFormat }}
            v-flex( xs12 sm6 )
                v-subheader( class="primary px-4" dark ) Descuentos
                v-subheader( class="blue px-4" dark ) Descuentos legales
                v-data-table( :headers="headers" hide-actions hide-headers :items="items.descuentosLegales" )
                    template( slot="items" slot-scope="props" :rowSpan="props.item.rowSpan || 0" )
                        td(v-if="props.item.value!==0 || props.item.name === 'Total descuentos legales'") {{ props.item.name }}
                        td(v-if="props.item.value!==0 || props.item.name === 'Total descuentos legales'" class="text-xs-right" width="40%" ) $ {{ props.item.value | mixThousandSeparatorFormat }}
            v-flex( xs12 sm6 )
                v-subheader( class="blue px-4" dark ) No imponibles
                v-data-table( :headers="headers" hide-actions hide-headers :items="items.noImponibles" )
                    template( slot="items" slot-scope="props" :rowSpan="props.item.rowSpan || 0" )
                        td {{ props.item.name }}
                        td( class="text-xs-right" width="40%" ) $ {{ props.item.value | mixThousandSeparatorFormat}}
            v-flex( xs12 sm6 )
                v-subheader( class="blue px-4" dark ) Descuentos personales
                v-data-table( :headers="headers" hide-actions hide-headers :items="items.descuentosPersonales" )
                    template( slot="items" slot-scope="props" :rowSpan="props.item.rowSpan || 0" )
                        td {{ props.item.name }}
                        td( class="text-xs-right" width="40%" ) $ {{ props.item.value | mixThousandSeparatorFormat }}
            v-flex( xs12 sm6 )
                v-subheader( class="primary px-4" dark ) Total haberes: $ {{ total_haberes | mixThousandSeparatorFormat }}
            v-flex( xs12 sm6 )
                v-subheader( class="primary px-4" dark ) Total descuentos: $ {{ total_discounts | mixThousandSeparatorFormat }}
            v-flex( xs12 )
                v-subheader( class="grey darken-4 px-4" dark ) Sueldo liquido: $ {{ total | mixThousandSeparatorFormat }}
</template>

<script>
import SalarySettlementService from '@/services/api/salarySettlement/'
/* mixins */
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
export default {
    name: 'salary-settlement-detail',
    props: {
        salarySettlementId: {
            type: Number,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: () => false
        },
    },
    data: function(){
        return {
            open: false,
            formData: null,
            headers: [
                { text: 'Item', value: 'name', sortable: false }, 
                { text: 'Valor', value: 'value', sortable: false },
            ],
            items: {
                descuentosLegales: [
                    { name: 'Cotización AFP', value: 0 },
                    { name: 'Cotización salud', value: 0 },
                    { name: 'Seguro de cesantía', value: 0 },
                    { name: 'Impuesto único', value: 0 },
                    //{ name: 'IPS', value: 0 },
                    //{ name: 'CCAF', value: 0 },
                    //{ name: 'Mutual Seguridad', value: 0 }, 
                    { name: 'Cuenta 2 de AFP', value: 0 },                   
                    { name: 'Total descuentos legales', value: 0 },
                ],
                descuentosPersonales: [
                    { name: 'Ahorro provisional voluntario', value: 0 },
                    { name: 'Avance o anticipo', value: 0 },                   
                    { name: 'Descuento CCAF', value: 0 },                    
                    { name: 'Prestamo Empresa', value: 0 }, 
                    { name: 'Descuento por planilla', value: 0 }, 
                    { name: 'Total descuentos personales', value: 0 },
                ],
                imponibles: [
                    { name: 'Sueldo base', value: 0 },
                    { name: 'Gratificación legal', value: 0 },
                    { name: 'Horas descuento', value: 0 },
                    { name: 'Horas extra', value: 0 },
                    { name: 'Comisiones', value: 0 },
                    { name: 'Bonos', value: 0 },
                    { name: 'Total imponible', value: 0 },
                ],
                noImponibles: [
                    { name: 'Colación', value: 0 },
                    { name: 'Movilización', value: 0 },
                    { name: 'Asignación familiar', value: 0 },
                    { name: 'Total no imponible', value: 0 },
                ],
            },
            total: 0,
            total_discounts: 0,
            total_haberes: 0,
        }
    },
    computed: {
        dynamicTittlePeriod: function() {
            return this.formData ? this.formData.period_month + '/' + this.formData.period_year : ''
        },
    },
    methods: {
        toggleOpen() {
            this.open = !this.open
        },
        getGeneralInfoRemunerations: async function() {
            //- Service to call detail to period of salary
            const customerInfo = await SalarySettlementService.fetchById(this.salarySettlementId)
            this.formData = customerInfo
            setTimeout(() => {
                this.fillFields(customerInfo)
            }, 50);
        },
        fillFields: function(data){
            console.log(data,'data')
            //
            this.resetItems()

            //
            console.log(data)

            //
            this.items.descuentosLegales[ 0 ].value = data.prevision_amount
            this.items.descuentosLegales[ 1 ].value = data.health_amount
            this.items.descuentosLegales[ 2 ].value = data.unemployment_insurance
            this.items.descuentosLegales[ 3 ].value = data.unique_tax_amount
            //this.items.descuentosLegales[ 4 ].value = data.ips_amount
            //this.items.descuentosLegales[ 5 ].value = data.ccaf_amount
            //this.items.descuentosLegales[ 6 ].value = data.mutual_amount
            this.items.descuentosLegales[ 4 ].value = data.apv_afp
            this.items.descuentosLegales[ 5 ].value = data.total_legal
            
            //
            this.items.descuentosPersonales[ 0 ].value = data.apv
            this.items.descuentosPersonales[ 1 ].value = data.advance
            this.items.descuentosPersonales[ 2 ].value = data.loan_ccaf_quote_amount
            this.items.descuentosPersonales[ 3 ].value = data.loan_company_quote_amount
            this.items.descuentosPersonales[ 4 ].value = data.internal_credit_amount || 0
            this.items.descuentosPersonales[ 5 ].value = data.total_personal

            //
            this.items.imponibles[ 0 ].value =  data.base_salary_proportional
            this.items.imponibles[ 1 ].value =  data.gratification
            this.items.imponibles[ 2 ].value =  data.amount_discount_hh
            this.items.imponibles[ 3 ].value =  data.amount_extra_hh
            this.items.imponibles[ 4 ].value =  data.commissions
            this.items.imponibles[ 5 ].value =  data.bonuses
            this.items.imponibles[ 6 ].value =  data.total_imponible

            //
            this.items.noImponibles[ 0 ].value =  data.hr_contract.collation
            this.items.noImponibles[ 1 ].value =  data.hr_contract.mobilization
            this.items.noImponibles[ 2 ].value =  data.family_assignment
            this.items.noImponibles[ 3 ].value =  data.total_no_imponible

            //
            this.total          = data.liquid_salary
            this.total_discounts= data.discounts
            this.total_haberes  = data.total_haberes

            //
            const assetsDiscounts               = data.hr_asset_discounts || []
                , imponiblesLength              = this.items.imponibles.length
                , noImponiblesLength            = this.items.noImponibles.length
                , descuentosLegalesLength       = this.items.descuentosLegales.length
                , descuentosPersonalesLength    = this.items.descuentosPersonales.length

            //
            assetsDiscounts.forEach( assetDiscount => {

                //
                const type   = assetDiscount.hr_asset_discount_type_id
                    , name   = assetDiscount.name
                    , amount = assetDiscount.pivot.amount
                    , value  = amount
                    , item   = { name, value }

                //
                switch ( type ) {
                    case 1: this.items.imponibles.splice( imponiblesLength - 1, 0, item ); break;
                    case 2: this.items.noImponibles.splice( noImponiblesLength - 1, 0, item ); break;
                    case 3: this.items.descuentosLegales.splice( descuentosLegalesLength - 1, 0, item ); break;
                    case 4: this.items.descuentosPersonales.splice( descuentosPersonalesLength - 1, 0, item ); break;
                }
            })

            //
            const imponiblesIndex           = this.items.imponibles.length - 1
                , noImponiblesIndex         = this.items.noImponibles.length - 1
                , descuentosLegalesIndex    = this.items.descuentosLegales.length - 1
                , descuentosPersonalesIndex = this.items.descuentosPersonales.length - 1

            //
            const imponiblesSpan            = this.items.descuentosLegales.length - this.items.imponibles.length
                , noImponiblesSpan          = this.items.noImponibles.length - this.items.descuentosPersonales.length
                , descuentosLegalesSpan     = this.items.imponibles.length - this.items.descuentosLegales.length
                , descuentosPersonalesSpan  = this.items.descuentosPersonales.length - this.items.noImponibles.length

            //
            this.items.imponibles[ imponiblesIndex ][ 'rowSpan' ] = imponiblesSpan
            this.items.noImponibles[ noImponiblesIndex ][ 'rowSpan' ] = noImponiblesSpan
            this.items.descuentosLegales[ descuentosLegalesIndex ][ 'rowSpan' ] = descuentosLegalesSpan
            this.items.descuentosPersonales[ descuentosPersonalesIndex ][ 'rowSpan' ] = descuentosPersonalesSpan
        },

        /**
         * 
         */
        resetItems () {
            this.items = {
                descuentosLegales: [
                    { name: 'Cotización AFP', value: 0 },
                    { name: 'Cotización salud', value: 0 },
                    { name: 'Seguro de cesantía', value: 0 },
                    { name: 'Impuesto único', value: 0 },
                    //{ name: 'IPS', value: 0 },
                    //{ name: 'IPS', value: 0 },
                    //{ name: 'CCAF', value: 0 },
                    //{ name: 'Mutual Seguridad', value: 0 },
                    { name: 'Cuenta 2 de AFP', value: 0 },  
                    { name: 'Total descuentos legales', value: 0 },
                ],
                descuentosPersonales: [
                    { name: 'Ahorro provisional voluntario', value: 0 },
                    { name: 'Avance o anticipo', value: 0 },                  
                    { name: 'Descuento CCAF', value: 0 },                    
                    { name: 'Prestamo Empresa', value: 0 }, 
                    { name: 'Descuento por planilla', value: 0 }, 
                    { name: 'Total descuentos personales', value: 0 },
                ],
                imponibles: [
                    { name: 'Sueldo base', value: 0 },
                    { name: 'Gratificación legal', value: 0 },
                    { name: 'Horas descuento', value: 0 },
                    { name: 'Horas extra', value: 0 },
                    { name: 'Comisiones', value: 0 },
                    { name: 'Bonos', value: 0 },
                    { name: 'Total imponible', value: 0 },
                ],
                noImponibles: [
                    { name: 'Colación', value: 0 },
                    { name: 'Movilización', value: 0 },
                    { name: 'Asignación familiar', value: 0 },
                    { name: 'Total no imponible', value: 0 },
                ],
            }
        },

        /**
         * 
         */
        submitPrint () {
            SalarySettlementService.print( this.salarySettlementId )
        },
    },
    watch: {
        open(val) {
            if (val == true) {
                this.getGeneralInfoRemunerations()
            }
        },
    },
    mixins:[TextFormatting],
    mounted: function(){
        this.getGeneralInfoRemunerations()
    },
}
</script>